import { useState } from "react";
import "./ATMBranchLocator.css";
import { getAuthToken } from "./Utility/util";
import html2pdf from "html2pdf.js";




const HARD_CODED_YEARS = [
  "2014-2015",
  "2015-2016",
  "2016-2017",
  "2017-2018",
  "2018-2019",
  "2019-2020",
  "2020-2021",
  "2021-2022",
  "2022-2023",
  "2023-2024",
  "2024-2025",
  "2025-2026",
];

const maskPAN = (pan) => {
  if (!pan || pan.length < 3) return pan;
  const firstTwo = pan.slice(0, 2);
  const lastOne = pan.slice(-1);
  return `${firstTwo}*****${lastOne}`;
};

export default StaffOTPLogin;

function StaffOTPLogin() {
  const [mobile, setMobile] = useState("");
  const [staffId, setStaffId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isValidUser, setIsValidUser] = useState(false);

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [tableData, setTableData] = useState([]);
  const [staffNumber, setStaffNumber] = useState("");
  const [pensionDetails, setPensionDetails] = useState(null);

  const [tenureYear, setTenureYear] = useState("");
  const [pensionYear, setPensionYear] = useState("");



  const parsePaidOnDate = (value, financialStartYear) => {
    if (!value) return null;


    if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
      const [day, month, year] = value.split("-");
      return new Date(`${year}-${month}-${day}`);
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [day, month, year] = value.split("/");
      return new Date(`${year}-${month}-${day}`);
    }


    if (/^\d{2}-[A-Za-z]{3}$/.test(value)) {
      const [day, monthText] = value.split("-");
      const monthIndex = new Date(`${monthText} 1, 2000`).getMonth();

      const year =
        monthIndex >= 3 ? financialStartYear : financialStartYear + 1;

      return new Date(year, monthIndex, parseInt(day));
    }

    return null;
  };

  const fetchPensionDetails = async (staffNo) => {
    const token = await getAuthToken();
    const filter = encodeURIComponent(`staffNumber eq '${staffNo}'`);

    const res = await fetch(
      `https://www.canarabank.bank.in/o/c/personaldetails?filter=${filter}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const data = await res.json();
    return data.items?.[0] || null;
  };

  const handleSearch = async () => {
    setError("");
    setIsValidUser(false);
    setYears([]);
    setSelectedYear("");
    setTableData([]);
    setPensionDetails(null);

    if (mobile.length !== 10) {
      setError("Enter valid 10-digit mobile number");
      return;
    }

    if (!staffId.trim()) {
      setError("Enter valid Staff ID");
      return;
    }

    try {
      setLoading(true);
      const token = await getAuthToken();

      const validateFilter =
        `phoneNumber eq '${mobile}' and staffId eq '${staffId}'`;

      const validateUrl =
        `https://www.canarabank.bank.in/o/c/pesionemployeedatas?filter=` +
        encodeURIComponent(validateFilter);

      const validateRes = await fetch(validateUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const validateData = await validateRes.json();

      if (!validateData.items?.length) {
        setError("Mobile number and Staff ID not found");
        return;
      }

      const employee = validateData.items[0];
      const staffNo = employee.staffId;

      setStaffNumber(staffNo);
      setYears(HARD_CODED_YEARS);
      setIsValidUser(true);

      const master = await fetchPensionDetails(staffNo);
      setPensionDetails(master);

    } catch {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleYearChange = async (year) => {
    setSelectedYear(year);
    setTableData([]);
    setError("");

    if (!year) return;

    const tenureYear = year.split("-")[0];
    const pensionYear = year.split("-")[1];
    setTenureYear(tenureYear);
    setPensionYear(pensionYear);

    try {
      setLoading(true);
      const token = await getAuthToken();

      const filter =
        `staffNumber eq '${staffNumber}' and pensionYear eq '${year}'`;

      const url =
        `https://www.canarabank.bank.in/o/c/pensiondetaildatas?filter=` +
        encodeURIComponent(filter);

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (!data.items?.length) {
        setError("No pension data for selected year");
        return;
      }

      const financialStartYear = parseInt(tenureYear);

      const sortedItems = [...data.items].sort((a, b) => {
        const aIsTotal =
          typeof a.details === "string" &&
          a.details.toLowerCase().includes("total");

        const bIsTotal =
          typeof b.details === "string" &&
          b.details.toLowerCase().includes("total");

        if (aIsTotal) return 1;
        if (bIsTotal) return -1;

        const dateA = parsePaidOnDate(a.details, financialStartYear);
        const dateB = parsePaidOnDate(b.details, financialStartYear);

        if (!dateA) return 1;
        if (!dateB) return -1;

        return dateB.getTime() - dateA.getTime(); // DESCENDING
      });

      setTableData(sortedItems);

    } catch {
      setError("Failed to load pension details");
    } finally {
      setLoading(false);
    }
  };


  const handlePrint = () => {
    const element = document.getElementById("pension-pdf-content");
    const opt = {
      margin: 0.5,
      filename: "pension-details.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    html2pdf().from(element).set(opt).save();
  };

  return (
    <div className="otp-outer">
      <div className="otp-box">

        <div className="otp-row">
          <div className="otp-field">
            <label>Mobile No<span className="req">*</span></label>
            <input
              value={mobile}
              maxLength={10}
              onChange={(e) =>
                setMobile(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>

          <div className="otp-field">
            <label>Staff ID<span className="req">*</span></label>
            <input
              value={staffId}
              onChange={(e) => setStaffId(e.target.value)}
            />
          </div>
        </div>

        {error && <p className="error-text">{error}</p>}

        <div className="otp-row">
          <button onClick={handleSearch} disabled={loading}>
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        {isValidUser && (
          <div className="otp-row">
            <div className="otp-field">
              <label>Select Pension Year</label>
              <select
                value={selectedYear}
                onChange={(e) => handleYearChange(e.target.value)}
              >
                <option value="">Select</option>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
          </div>
        )}
{(pensionDetails || tableData.length > 0) && (
          <div>
            <div id="pension-pdf-content">
              {pensionDetails && (
                <div className="otp-row">
                  <div className="table-wrapper">
                    <table className="result-table">
                      <thead>
                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            CANARA BANK (EMPLOYEES’) PENSION FUND
                          </th>
                        </tr>

                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            HUMAN RESOURCES WING
                          </th>
                        </tr>

                        <tr>
                          <th colSpan="4" style={{ textAlign: "center" }}>
                            NAVEEN COMPLEX, HEAD OFFICE ANNEXE, 1, M G ROAD,
                            BENGALURU-560001
                          </th>
                        </tr>

                        {tenureYear && pensionYear && (
                          <tr>
                            <th colSpan="4" style={{ textAlign: "center" }}>
                              REGULAR PENSION DISBURSEMENT DETAILS FOR THE
                              PERIOD{" "}
                              <b>01/04/{tenureYear}</b> AND{" "}
                              <b>31/03/{pensionYear}</b>
                            </th>
                          </tr>
                        )}
                      </thead>

                      <tbody>
                        <tr>
                          <th>Name</th>
                          <td>{pensionDetails.name}</td>
                          <th>Basic Pension</th>
                          <td>{pensionDetails.basicPension}</td>
                        </tr>
                        <tr>
                          <th>Staff Number</th>
                          <td>{pensionDetails.staffNumber}</td>
                          <th>Additional Pension</th>
                          <td>{pensionDetails.addPension || 0}</td>
                        </tr>
                        <tr>
                          <th>PPO Number</th>
                          <td>{pensionDetails.pFONumber}</td>
                          <th>Commutation Amount</th>
                          <td>{pensionDetails.commutationAmount}</td>
                        </tr>
                        <tr>
                          <th>Date of Sanction</th>
                          <td>{pensionDetails.sanctionDate}</td>
                          <th>Crediting Branch</th>
                          <td>{pensionDetails.creditingBranch}</td>
                        </tr>
                        <tr>
                          <th>Pension After Comm.</th>
                          <td>{pensionDetails.afterCommutation}</td>
                          <th>PAN No.</th>
                          <td>{maskPAN(pensionDetails.pAN)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {tableData.length > 0 && (
                <div className="otp-row">
                  <div className="table-wrapper">
                    <table className="result-table">
                      <thead>
                        <tr>
                          <th>Paid On</th>
                          <th>Pension Paid For</th>
                          <th>Basic</th>
                          <th>Ex Gratia</th>
                          <th>Ex Gratia 12BPS</th>
                          <th>DR</th>
                          <th>Total</th>
                          <th>IT</th>
                          <th>DeD</th>
                          <th>Net Paid</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((row) => (
                          <tr key={row.id}>
                            <td>{row.details}</td>
                            <td>
                              {(() => {
                                const date = parsePaidOnDate(
                                  row.details,
                                  parseInt(tenureYear)
                                );
                                if (!date) return row.pensionYear;

                                const month = date.toLocaleString("en-IN", {
                                  month: "long",
                                });
                                const year = date.getFullYear();

                                return `${month} ${year}`;
                              })()}
                            </td>
                            <td>{row.basic}</td>
                            <td>{row.exGratia || 0}</td>
                            <td>{row.exGratia12BPS || 0}</td>
                            <td>{row.dR}</td>
                            <td>{row.total}</td>
                            <td>{row.iT || 0}</td>
                            <td>{row.dD || 0}</td>
                            <td>{row.netPaid}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                
              )}
            </div>
             <div className="otp-row">
              <button onClick={handlePrint} className="print-button">
                Print
              </button>
            </div>
          </div>
        )}
          

      </div>
    </div>
  );
}